<div #componentWrapper class="advanced-chip-select-container" [formGroup]="optionsFormGroup"
    [attr.aria-labelledby]="_formField?.getLabelId()" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
    <!-- -->
    <mat-chip-grid #itemsChipGrid aria-label="Select relevant items" [disabled]="_disabledSignal()">
        @for (o of selectedItems(); track o.value) {
        <mat-chip-row [removable]="true" (removed)="removeItem(o)" class="n-my-chip-row" style="align-items: baseline;" [matTooltip]="o.label">
            <span>
                {{ o.label }}
            </span>
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip-row>
        }
        <input matInput #inputEl [placeholder]="placeholder" [disabled]="_disabledSignal()" [value]="filterString()"
            [matChipInputFor]="itemsChipGrid" (focus)="onFilterFocus()" (input)="onFilterChange($event)"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addItemToList($event)" />
    </mat-chip-grid>
    <!-- Overlay content -->
    <ng-template #panelTemplate>
        <div class="dropdown-panel">
            @for (option of filteredItems(); track option.value) {
            @if (option.isGroup ) {
            @if(option.children?.length) {
            <div class="group-option">
                <button matIconButton class="group-toggle-button" (click)="toggleGroup(option)"><mat-icon
                        [class.expanded]="isExpanded(option.label)()">keyboard_arrow_right</mat-icon></button>
                {{ option.label }}
            </div>
            @if (isExpanded(option.label)() && option.children?.length ) {
            <div class="sublist" [class.open]="isExpanded(option.label)()">
                @for (child of option.children; track child.value) {
                <div class="child-option no-checkbox-option" (click)="addItem(child)">
                    <div>{{ child.label }}</div>
                </div>
                }
            </div>
            }
            }
            }
            @else {
            <div class="option  no-checkbox-option" (click)="addItem(option)">
                <div>{{ option.label }}</div>
            </div>
            }
            }
        </div>
    </ng-template>
</div>